import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Splash from './Splash'

function Auth({ authPending, children }) {
	if (authPending) {
		return <Splash />
	}

	return children
}

Auth.propTypes = {
	children: PropTypes.node,
	authPending: PropTypes.bool.isRequired,
}

Auth.defaultProps = {
	children: null,
}

const mapStateToProps = ({ app }) => ({
	authPending: app.authPending,
})

const Container = connect(
  mapStateToProps,
)(Auth)

export default Container



// WEBPACK FOOTER //
// ./src/components/Auth.jsx